import React, { useState, useEffect } from 'react'
import { CustomTooltip } from '../CustomToolTip/CustomToolTip'

interface CopyTextTooltipProps {
  child: string | number
}

const CopyTextTooltip: React.FC<CopyTextTooltipProps> = ({ child }) => {
  const [copyText, setCopyText] = useState('')
  useEffect(() => {
    if (copyText) {
      const timer = setTimeout(() => {
        setCopyText('')
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [copyText])

  const handleCopyText = async (e: any, text: string) => {
    e.preventDefault()
    e.stopPropagation()
    try {
      await navigator.clipboard.writeText(text)
      setCopyText(text)
    } catch (err) {
      console.error(err)
    }
  }
  return (
    <CustomTooltip
      title={copyText ? 'Copied!' : 'Click to copy'}
      placement='top'
      slotProps={{
        tooltip: {
          sx: {
            position: 'relative',
            top: '0.1rem',
            color: '#402080',
            backgroundColor: '#ECE9F2',
          },
        },
      }}
    >
      <span onClick={(e) => handleCopyText(e, String(child))}>{child}</span>
    </CustomTooltip>
  )
}

export default CopyTextTooltip
